// extracted by mini-css-extract-plugin
export var divider = "_n9-0";
export var systemMessage = "_n9-1";
export var systemMessageWrapper = "_n9-2";